import ApiClient from './ApiClient';

class MinerClient extends ApiClient {
  constructor(url) {
    super(url ? `${url}` : '');
  }

  async updateMinerField(id, updateFieldKey, value) {
    const endpointMap = {
      macAddress: '/miner/macaddress',
      workerName: '/miner/workername',
      locationId: '/miner/location',
      ipAddress: '/miner/ip-address',
      serialNumber: '/miner/serialNumber',
      name: '/miner/name'
    };

    const endpoint = endpointMap[updateFieldKey];
    if (!endpoint) {
      throw new Error(`Unknown update field: ${updateFieldKey}`);
    }

    const payload = {
      minerId: id,
      [updateFieldKey]: value
    };

    try {
      if (updateFieldKey === 'ipAddress') {
        return await this.put(endpoint, payload);
      } else {
        return await this.post(endpoint, payload);
      }
    } catch (error) {
      throw new Error(`Failed to update ${updateFieldKey}: ${error.message}`);
    }
  }

  async getMinerConsumption(id) {
    try {
      return await this.get(`/miner/${id}/calculations`);
    } catch (error) {
      throw new Error(`Failed to get miner consumption: ${error.message}`);
    }
  }

  async updateMinerConnectedPool(id, value) {
    try {
      return await this.put(`/miners/${id}/pool`, {
        poolId: value
      });
    } catch (error) {
      throw new Error(
        `Failed to connect miner to a new pool: ${error.message}`
      );
    }
  }

  async updateMinerOwner(id, newUserId, contractId) {
    try {
      return await this.put(`/miners/${id}/owner`, {
        newUserId,
        contractId
      });
    } catch (error) {
      throw new Error(`Failed to change miner owner: ${error.message}`);
    }
  }

  async addMiner(data) {
    try {
      return await this.post(`/miners`, data);
    } catch (error) {
      throw new Error(`Failed to add miner: ${error.message}`);
    }
  }

  async getMinerTypes() {
    try {
      return await this.get(`/miner-types`);
    } catch (error) {
      throw new Error(`Failed to get miner types: ${error.message}`);
    }
  }

  async deleteMiner(id) {
    try {
      return await this.delete(`/miners/${id}`);
    } catch (error) {
      throw new Error(`Failed to delete miner: ${error.message}`);
    }
  }
}

export default MinerClient;
